import React, { useState, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import { Table, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import SVG from "react-inlinesvg";
import Upload from "../../../src/app/Images/upload.png";
import "react-datepicker/dist/react-datepicker.css";
// import "../../Maincatogry.css";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import Modal from "react-bootstrap/Modal";

import Imagecard from "./Imagecard";
import { baseUrl } from "../../services/config";
import Axios from "axios";
import toast from "react-hot-toast";
import { Formik, useFormik, Form as FormikForm, Field, } from "formik";
import * as Yup from "yup";
import { Input } from "../../_metronic/_partials/controls";

const Updatecomponent = ({ show, hide, url, type, reload, wallpaperobject, isFirst, title, foldable, Location }) => {
  console.log("🚀 ~???????????  wallpaperobject:", wallpaperobject)

  const authToken = localStorage.getItem("userToken");
  
  // Original single image state
  const [updateimg, setupdateimg] = useState("");
  const [imgError, setimgError] = useState("");
  
  // New dual image states
  const [stretchedImage, setStretchedImage] = useState("");
  const [fullscreenImage, setFullscreenImage] = useState("");
  const [stretchedImageError, setStretchedImageError] = useState("");
  const [fullscreenImageError, setFullscreenImageError] = useState("");
  
  const [loading, setloading] = useState(false);

  // Helper function to check if URL is valid/present
  const hasValidUrl = () => {
    const urlToCheck = wallpaperobject?.url || url;
    return urlToCheck && urlToCheck.trim() !== "" && urlToCheck !== null && urlToCheck !== undefined;
  };

  // Determine initial main option based on existing data
  const getInitialMainOption = () => {
    // If foldable is false, always use URL
    if (!Location) {
      return "url";
    }
    
    // If URL is null/empty, default to navigation
    if (!hasValidUrl()) {
      return "navigation";
    }
    
    // If navigation flags are set to true, use navigation
    if (wallpaperobject?.is_navigate_to_gems === "true" || 
        wallpaperobject?.is_navigate_to_gems === true ||
        wallpaperobject?.is_navigate_to_rewards === "true" || 
        wallpaperobject?.is_navigate_to_rewards === true) {
      return "navigation";
    }
    
    // Otherwise, use URL
    return "url";
  };

  // Determine initial navigation value based on existing data
  const getInitialNavigation = () => {
    // If foldable is false, return empty since navigation won't be used
    if (!Location) {
      return "";
    }
    
    // Check for gems navigation (both string and boolean values)
    if (wallpaperobject?.is_navigate_to_gems === "true" || wallpaperobject?.is_navigate_to_gems === true) {
      return "gems";
    }
    
    // Check for rewards navigation (both string and boolean values)
    if (wallpaperobject?.is_navigate_to_rewards === "true" || wallpaperobject?.is_navigate_to_rewards === true) {
      return "rewards";
    }
    
    // If no URL is present, default to rewards as per your requirement
    if (!hasValidUrl()) {
      return "rewards";
    }
    
    return "gems"; // fallback
  };

  // Get initial URL value
  const getInitialUrl = () => {
    if (isFirst) {
      return "https://www.google.com";
    }
    
    // Use wallpaperobject.url first, then fallback to url prop
    const urlValue = wallpaperobject?.url || url;
    return urlValue && urlValue.trim() !== "" ? urlValue : "";
  };

  const LoginSchema = Yup.object().shape({
    url: Yup.string().when('mainOption', {
      is: 'url',
      then: () => Yup.string()
        .required('Url is Required')
        .matches(/^(http[s]?:\/\/){0,1}(w{3,3}\.)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]/,
          "Url must begin with http or https:// and end with .com "
        ),
      otherwise: () => {
        if (!Location) {
          // If not foldable, URL is always required
          return Yup.string()
            .required('Url is Required')
            .matches(/^(http[s]?:\/\/){0,1}(w{3,3}\.)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]/,
              "Url must begin with http or https:// and end with .com "
            );
        }
        // If foldable and navigation is selected, URL is not required
        return Yup.string().notRequired();
      }
    }),
    navigation: Yup.string().when('mainOption', {
      is: 'navigation',
      then: () => Yup.string().oneOf(['gems', 'rewards'], 'Please select a navigation option'),
      otherwise: () => Yup.string().notRequired()
    })
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const initialValues = {
    mainOption: getInitialMainOption(),
    url: getInitialUrl(),
    navigation: getInitialNavigation(),
  };

  console.log("Initial Values:", initialValues); // Debug log

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {
      // Conditional validation based on Location
      if (Location) {
        // New behavior: Optional dual images (user can update one or both)
        // No validation needed for update - images are optional
        Updatsave(values, resetForm);
      } else {
        // Original behavior: Single image (optional for update)
        Updatsave(values, resetForm);
      }
    },
  })

  //start update api
  const Updatsave = (values) => {
    console.log("Form Values on Submit:", values)
    const fdata = new FormData();
    fdata.append("type", type);
    
    // Handle URL based on main option selection or foldable state
    if (!Location || values.mainOption === "url") {
      fdata.append("url", values.url);
      // Always set navigation options to false when URL is selected or foldable is false
      fdata.append("is_navigate_to_gems", "0");
      fdata.append("is_navigate_to_rewards", "0");
    } else {
      // When navigation is selected, don't pass URL or set it empty
      fdata.append("url", "");
      // Set navigation based on selection - ensure one is true, other is false
      fdata.append("is_navigate_to_gems", values.navigation === "gems" ? "1" : "0");
      fdata.append("is_navigate_to_rewards", values.navigation === "rewards" ? "1" : "0");
    }

    // Conditional image appending based on Location
    if (Location) {
      // New behavior: Append dual images if provided
      if (fullscreenImage) {
        fdata.append("fullscreen_image", fullscreenImage);
      }
      if (stretchedImage) {
        fdata.append("stretched_image", stretchedImage);
      }
    } else {
      // Original behavior: Append single image if provided
      if (updateimg) {
        fdata.append("image", updateimg);
      }
    }

    let url1 = `admin/banners/${wallpaperobject.id}?_method=PUT`;
    let url2 = `admin/fold-able-banners/${wallpaperobject.id}?_method=PUT`;

    setloading(true);
    fetch(`${baseUrl}/${foldable ? url2 : url1}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
      body: fdata,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data.metadata.success) {
          toast.success('Updated Successfully')
          hide();
          reload();
          setloading(false);
          
          // Reset images based on Location
          if (Location) {
            setFullscreenImage("");
            setStretchedImage("");
            setFullscreenImageError("");
            setStretchedImageError("");
          } else {
            setupdateimg("");
            setimgError("");
          }
        }
        else if (!data.metadata.success) {
          Object.values(data.metadata.message).map(msg => {
            toast.error(msg)
            setloading(false)
          })
        }
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
      });
  };
  //end update api

  return (
    <Modal
      show={show}
      onHide={hide}
      animation={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 'bold', fontSize: '24px' }}>{title}</Modal.Title>
      </Modal.Header>
      {loading === true ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div className="spinner-border text-dark p-5 m-5" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <Modal.Body className="row">
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework"
          >
            {/* Main Option Selection - Only show if foldable is true */}
            {Location && (
              <Form.Group className="mb-3 col-md-12">
                <Form.Label style={{ fontWeight: 'bold', fontSize: '18px' }}>Choose Option</Form.Label>
                <div className="mt-2 d-flex">
                  <Form.Check
                    type="radio"
                    id="edit-option-url"
                    name="mainOption"
                    value="url"
                    label="URL"
                    checked={formik.values.mainOption === "url"}
                    onChange={formik.handleChange}
                    className="me-4"
                  />
                  <Form.Check
                    type="radio"
                    id="edit-option-navigation"
                    name="mainOption"
                    value="navigation"
                    label="Navigation"
                    checked={formik.values.mainOption === "navigation"}
                    onChange={(e) => {
                      formik.handleChange(e);
                      // Set default navigation value when switching to navigation option
                      if (e.target.value === "navigation") {
                        // If current navigation is none or empty, set to gems
                        if (!formik.values.navigation || formik.values.navigation === "none") {
                          formik.setFieldValue("navigation", "gems");
                        }
                      }
                    }}
                    className="mx-2"
                  />
                </div>
              </Form.Group>
            )}

            {/* URL Field - Show when foldable is false OR when foldable is true and URL option is selected */}
            {(!Location || formik.values.mainOption === "url") && !isFirst && (
              <Form.Group className="mb-3 col-md-12" controlId="formBasicEmail">
                <Form.Label style={{ fontWeight: 'bold', fontSize: '18px' }}>
                  {!Location ? 'URL' : 'URL'}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="url"
                  placeholder="URL"
                  style={{ height: '4rem' }}
                  className={`form-control form-control-lg form-control-solid ${getInputClasses("url")}`}
                  {...formik.getFieldProps("url")}
                />
                {formik.touched.url && formik.errors.url ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.url}</div>
                  </div>
                ) : null}
              </Form.Group>
            )}

            {/* Navigation Options - Show only when foldable is true AND Navigation option is selected */}
            {Location && formik.values.mainOption === "navigation" && (
              <Form.Group className="mb-3 col-md-12">
                <Form.Label style={{ fontWeight: 'bold', fontSize: '18px' }}>Choose Navigation</Form.Label>
                <div className="mt-2 d-flex">
                  <Form.Check
                    type="radio"
                    id="edit-navigate-gems"
                    name="navigation"
                    value="gems"
                    label="Navigate to Gems"
                    checked={formik.values.navigation === "gems"}
                    onChange={formik.handleChange}
                    className="me-4"
                  />
                  <Form.Check
                    type="radio"
                    id="edit-navigate-rewards"
                    name="navigation"
                    value="rewards"
                    label="Navigate to Subscription"
                    checked={formik.values.navigation === "rewards"}
                    onChange={formik.handleChange}
                    className="mx-2"
                  />
                </div>
                {formik.touched.navigation && formik.errors.navigation ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.navigation}</div>
                  </div>
                ) : null}
              </Form.Group>
            )}

            {/* Conditional File Upload based on Location */}
            {Location ? (
              // NEW: Two side-by-side uploads when Location is true
              <div className="col-12">
                <div className="row">
                      {/* Fullscreen Image Upload */}
                  <div className="col-md-6">
                    <div
                      className="avatar-upload-input text-center"
                      style={{ marginTop: "20px" }}
                    >
                      <img src={Upload} alt="img" />
                      <h2 className="mt-3">Upload Inner Image</h2>
                      <div className="avatar-edit-input">
                        <input
                          className="btn btn-base"
                          style={{ textAlignLast: "center" }}
                          type="file"
                          onChange={(e) => {
                            setFullscreenImageError("");
                            setFullscreenImage(e.target.files[0]);
                          }}
                          name="fullscreen_image"
                          id="fullscreenImageUpload"
                          accept=".png, .jpg, .jpeg"
                        />
                        {fullscreenImage && (
                          <div className="text-success mt-2">
                            <small>✓ {fullscreenImage.name}</small>
                          </div>
                        )}
                        {fullscreenImageError ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block text-danger">{fullscreenImageError}</div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    
                    {/* Current Fullscreen Image Preview */}
                    {(wallpaperobject?.fullscreen_image?.original_url || wallpaperobject?.fullscreen_image) && (
                      <div className="mt-3 text-center">
                        <img
                          width={150}
                          height={150}
                          style={{ borderRadius: "10px" }}
                          src={wallpaperobject?.fullscreen_image?.original_url || wallpaperobject?.fullscreen_image}
                          alt="current fullscreen img"
                        />
                        <div style={{ color: "red", marginTop: "5px" }}>Current Inner Image</div>
                      </div>
                    )}
                  </div>
                  {/* Stretched Image Upload */}
                  <div className="col-md-6">
                    <div
                      className="avatar-upload-input text-center"
                      style={{ marginTop: "20px" }}
                    >
                      <img src={Upload} alt="img" />
                      <h2 className="mt-3">Upload Outer Image</h2>
                      <div className="avatar-edit-input">
                        <input
                          className="btn btn-base"
                          style={{ textAlignLast: "center" }}
                          type="file"
                          onChange={(e) => {
                            setStretchedImageError("");
                            setStretchedImage(e.target.files[0]);
                          }}
                          name="stretched_image"
                          id="stretchedImageUpload"
                          accept=".png, .jpg, .jpeg"
                        />
                        {stretchedImage && (
                          <div className="text-success mt-2">
                            <small>✓ {stretchedImage.name}</small>
                          </div>
                        )}
                        {stretchedImageError ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block text-danger">{stretchedImageError}</div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    
                    {/* Current Stretched Image Preview */}
                    {(wallpaperobject?.stretched_image?.original_url || wallpaperobject?.stretched_image) && (
                      <div className="mt-3 text-center">
                        <img
                          width={150}
                          height={150}
                          style={{ borderRadius: "10px" }}
                          src={wallpaperobject?.stretched_image?.original_url || wallpaperobject?.stretched_image}
                          alt="current stretched img"
                        />
                        <div style={{ color: "red", marginTop: "5px" }}>Current Outer Image</div>
                      </div>
                    )}
                  </div>

              
                </div>
              </div>
            ) : (
              // ORIGINAL: Single upload when Location is false
              <>
                <div className="col-12">
                  <div
                    className="avatar-upload-input text-center"
                    style={{ marginTop: "20px" }}
                  >
                    <img src={Upload} alt="img" />
                    <h2 className="mt-3">Upload File</h2>

                    <div className="avatar-edit-input">
                      <input
                        onChange={(e) => {
                          setimgError("")
                          setupdateimg(e.target.files[0]);
                        }}
                        className="btn btn-base"
                        style={{ textAlignLast: "center" }}
                        type="file"
                        id="imageUpload"
                        accept=".png, .jpg, .jpeg"
                      />

                      {imgError ? (
                        <div className="fv-plugins-message-container">
                          <div className="fv-help-block">{imgError}</div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* Current Image Preview */}
                <div className="mt-3">
                  <img
                    width={150}
                    height={150}
                    style={{ borderRadius: "10px" }}
                    src={wallpaperobject?.image?.original_url}
                    alt="current img"
                  />
                  <span style={{ color: "red", marginLeft: "5px" }}>Current Image</span>
                </div>
              </>
            )}
          </form>
        </Modal.Body>
      )}

      <Modal.Footer>
        <Button variant="secondary" onClick={hide}>
          Close
        </Button>
        <Button type="submit" variant="primary" onClick={formik.handleSubmit}>
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Updatecomponent;